import React from 'react'
import { Helmet } from 'react-helmet'
import { useSelector } from 'react-redux'
import BackgroundPageContent from 'src/components/BackgroundPageContent/BackgroundPageContent'
import BudgetsContent from 'src/components/BudgetsContent/BudgetsContent'
import { selectBudgetsAllBudgetsMatch } from 'src/redux/selectors/router.selectors'
import { selectAppName } from 'src/redux/selectors/session.selectors'

const BudgetsAllBudgets: React.FC = () => {
  const appName = useSelector(selectAppName)
  const budgetsAllBudgetsMatch = useSelector(selectBudgetsAllBudgetsMatch)
  const allOrYour = budgetsAllBudgetsMatch ? 'All' : 'Your'

  return (
    <>
      <Helmet>
        <title>{`${allOrYour} Budgets | ${appName}`}</title>
        <meta
          name="description"
          content={`${allOrYour} Budgets page of ${appName}`}
        />
      </Helmet>
      <BackgroundPageContent noStackingIndex noPadding>
        <BudgetsContent />
      </BackgroundPageContent>
    </>
  )
}

export default BudgetsAllBudgets
